var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspacepremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_405_978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.194336,
    width: 44,
    height: 44,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_405_978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.932 25.1166L19.5362 19.8916L15.3195 16.5H20.5445L22.1945 11.3666L23.8445 16.5H29.0695L24.807 19.8916L26.4112 25.1166L22.1945 21.8625L17.932 25.1166ZM11.1945 42.1666V28.0041C10.0334 26.7208 9.132 25.2541 8.49033 23.6041C7.84867 21.9541 7.52783 20.1972 7.52783 18.3333C7.52783 14.2388 8.94867 10.7708 11.7903 7.92913C14.632 5.08746 18.1001 3.66663 22.1945 3.66663C26.2889 3.66663 29.757 5.08746 32.5987 7.92913C35.4403 10.7708 36.8612 14.2388 36.8612 18.3333C36.8612 20.1972 36.5403 21.9541 35.8987 23.6041C35.257 25.2541 34.3556 26.7208 33.1945 28.0041V42.1666L22.1945 38.5L11.1945 42.1666ZM22.1945 29.3333C25.2501 29.3333 27.8473 28.2638 29.9862 26.125C32.1251 23.9861 33.1945 21.3888 33.1945 18.3333C33.1945 15.2777 32.1251 12.6805 29.9862 10.5416C27.8473 8.40274 25.2501 7.33329 22.1945 7.33329C19.1389 7.33329 16.5417 8.40274 14.4028 10.5416C12.2639 12.6805 11.1945 15.2777 11.1945 18.3333C11.1945 21.3888 12.2639 23.9861 14.4028 26.125C16.5417 28.2638 19.1389 29.3333 22.1945 29.3333ZM14.8612 36.7125L22.1945 34.8333L29.5278 36.7125V31.0291C28.4584 31.6402 27.3052 32.1212 26.0683 32.472C24.8302 32.824 23.5389 33 22.1945 33C20.8501 33 19.5588 32.824 18.3207 32.472C17.0838 32.1212 15.9306 31.6402 14.8612 31.0291V36.7125Z",
    fill: "#25608A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspacepremium);
export default __webpack_public_path__ + "static/media/workspacepremium.f4715516685f5476cc5111a90ae1cb4a.svg";
export { ForwardRef as ReactComponent };